import React, { Component } from "react";
import "./style.css";
import "../../../../../index.css";
class TrinityConditionNext extends Component {
  render() {
    const { handleNext, statInfoVisible, statInfo } = this.props;
    return (
      <div className="trinityConditionNext_box">
        <div className="trinityConditionNext_stat_box">
          <div className={statInfoVisible === true ? "" : "display_none"}>
            <span>总计：</span>
            <span className={statInfo["A"] === 0 ? "display_none" : ""}>
              {statInfo["A"]}A{" "}
            </span>
            <span className={statInfo["B"] === 0 ? "display_none" : ""}>
              {statInfo["B"]}B{" "}
            </span>
            <span className={statInfo["C"] === 0 ? "display_none" : ""}>
              {statInfo["C"]}C{" "}
            </span>
            <span className={statInfo["D"] === 0 ? "display_none" : ""}>
              {statInfo["D"]}D{" "}
            </span>
            <span className={statInfo["E"] === 0 ? "display_none" : ""}>
              {statInfo["E"]}E{" "}
            </span>
          </div>
        </div>
        <div
          onClick={() => handleNext()}
          className="trinityConditionNext_btn_box"
        >
          下一步
        </div>
      </div>
    );
  }
}

export default TrinityConditionNext;



// WEBPACK FOOTER //
// ./src/containers/Trinity/TrinityCondition/components/TrinityConditionNext/index.js